{
    "Accessibility menu": "Meni dostopnosti",
    "Reset settings": "Ponastavi nastavitve",
    "Close": "Zapri",
    "Content adjustments": "Prilagoditve vsebine",
    "Navigation adjustments": "Prilagoditve navigacije",
    "Align Left": "Poravnaj levo",
    "Adjust Font Size": "Prilagodi velikost pisave",
    "Highlight Title": "Označi naslov",
    "Highlight Links": "Označi povezave",
    "Readable Font": "Bralna pisava",
    "Colour adjustments": "Prilagoditve barv",
    "Dark Contrast": "Temni kontrast",
    "Light Contrast": "Svetli kontrast",
    "High Contrast": "Visoki kontrast",
    "High Saturation": "Visoka nasičenost",
    "Low Saturation": "Nizka nasičenost",
    "Monochrome": "Monokromno",
    "Tools": "Orodja",
    "Reading Guide": "Bralni vodnik",
    "Stop Animations": "Ustavi animacije",
    "Big Cursor": "Velik kazalec",
    "Increase Font Size": "Povečaj velikost pisave",
    "Decrease Font Size": "Zmanjšaj velikost pisave",
    "Letter Spacing": "Razmik med črkami",
    "Line Height": "Višina vrstice",
    "Font Weight": "Debelina pisave",
    "Dyslexia Font": "Pisava za disleksijo",
    "Language": "Jezik",
    "Accessibility widget": "Odpri meni dostopnosti",
    "Accessibility Profiles": "Profili dostopnosti",
    "Cognitive Disability": "Kognitivna oviranost",
    "Seizure Safe": "Varno za napade",
    "Accessibility statement": "Izjava o dostopnosti"
}